module.exports = __webpack_public_path__ + "static/head-bg.9b32ae84.png";